import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_STATE } from '../state';
import * as reducers from './reducers';
import { addSignInCase } from './async-thunks';

const commonSlice = createSlice({
    name: 'common',
    initialState: INITIAL_STATE,
    reducers: { ...reducers },
    extraReducers: (builder) => {
        addSignInCase(builder);
    }
});

export default commonSlice.reducer;
export const {
    sendRequest,
    receiveResponse,
    openDrawer,
    closeDrawer,
    openSnackbar,
    closeSnackbar,
    signOut
} = commonSlice.actions;

export { signIn } from './async-thunks'
